import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { useMediaQuery } from "@mui/system";

interface Input {
  title: string;
  description: string;
  image: string;
}

export default function HomeCards({ title, description, image }: Input) {
  const isMobile = useMediaQuery("(max-width:600px)");
  return (
    <Card
      sx={{
        maxWidth: isMobile ? 200 : 300, // Adjusting maxWidth for a better proportion
        height: isMobile ? 180 : 225, // Using a 4:3 ratio (width:height)
        display: "flex", // Flex to control layout
        flexDirection: isMobile ? "column" : "column", // Stack items
      }}
    >
      <CardMedia
        sx={{
          height: isMobile ? 200 : 300, // Adjust image height for mobile
          width: isMobile ? 180 : 225, // Adjust width for mobile
          objectFit: "cover",
          borderRadius: "0.2rem",
        }}
        image={image}
      />
      <CardContent
        sx={{
          overflow: "hidden",
          textAlign: "left", // Center text on mobile
        }}
      >
        <Typography
          gutterBottom
          variant="body1"
          component="div"
          fontWeight="bold"
          sx={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            fontSize: isMobile ? "0.4rem" : "0.6rem", // Adjust font size for mobile
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: isMobile ? 2 : 3, // Adjust line clamp for mobile
            WebkitBoxOrient: "vertical",
            fontSize: isMobile ? "0.4rem" : "0.6rem", // Adjust font size for mobile
          }}
        >
          {description}
        </Typography>
      </CardContent>
    </Card>
  );
}
